<div class="fallback-tile">
   <p> {{ tileConfig.tile.name ?? 'Absent tile' }} is not a valid tile </p>
</div>
